module.exports = __webpack_public_path__ + "static/media/image-Tattoo-Color.e8aa42cd.png";